import loader from "../images/loader-faturamento.gif";

export const CustomLoading = () => (
  <img src={loader} alt="loading..." style={{ width: 80, height: 80 }} />
);
